export const constants ={
    ITEM_THONG_TIN:"item-thong-tin-active",
    ITEM_HOME:"item-home-active",
    ITEM_VAN_CHUYEN: "item-van-chuyen",
    ITEM_HANG_XACH_TAY:"item-hang-xach-tay",
    ITEM_CHI_NHANH_VN: "item-chi-nhanh-vn",
    ITEM_CHI_NHANH_JP: "item-chi-nhanh-jp",
    FIRST_LOAD: "first-load",

}

export default constants